// components
import maAdminView from '../adminView'
import maFilters from '../../components/filters'
import maPaginator from '@/components/paginator'
import maModal from '@/components/modal'
import maInputText from '@/components/input/modules/text'
import maInputSelect from '@/components/input/modules/select'
import maEmpty from '@/components/empty'

// api
import {
  apiGetAdminAjustage,
  apiPatchAdminAjustage,
  apiDeleteAdminAjustage
} from '@/services/API/adminGag'

export default {
  name: 'ajustage',
  data: function () {
    return {
      ajustage: {
        interval_age_start: null,
        interval_age_end: null,
        interval_age_start_new: null,
        interval_age_end_new: null,
        age_coef: null
      }
    }
  },
  extends: maAdminView,
  components: {
    maPaginator,
    maFilters,
    maModal,
    maInputText,
    maInputSelect,
    maEmpty
  },
  methods: {
    handleSearch: function () {
      apiGetAdminAjustage(this.currentPage)
        .then(ajustage => {
          this.table = ajustage.results.map(item => {
            item.interval_age_start_new = item.interval_age_start
            item.interval_age_end_new = item.interval_age_end
            return item
          })

          this.totalPages = ajustage.total_pages || 0
        })
    },
    handleEdit: function (data) {
      this.ajustage = data
      this.$refs.adminGagEditModal.showModal = true
    },
    handleDelete: function (data) {
      apiDeleteAdminAjustage(data).then(() => {
        this.handleSearch()
        this.throwNotification(this.$t('notifications.paramChanged.title'), this.$t('notifications.paramChanged.body'), 'OK')
      })
    },
    handleSave: function () {
      apiPatchAdminAjustage(this.ajustage)
        .then(() => {
          this.handleSearch()
          this.throwNotification(this.$t('notifications.paramChanged.title'), this.$t('notifications.paramChanged.body'), 'OK')
          this.$refs.adminGagEditModal.showModal = false
        })
        .catch(() => {
          this.throwNotification(this.$t('notifications.error.0.title'), this.$t('notifications.error.0.body'), 'KO')
        })
    },
    resetEditValues: function () {
      if (this.ajustage) {
        Object.keys(this.ajustage).forEach(item => (item = null))
      }
    }
  }
}
